import React, { FunctionComponent } from 'react';
import variantSelectorBaseStyles from './variantSelectorStyles';
import { useExpandSections } from '../../../../../hooks/navigation/useExpandSections';
import GenericAccordion from '../../../../../../common/components/presentation/genericAccordion/GenericAccordion';
import FeatureSectionTitleContainer from '../../featureSection/FeatureSectionTitleContainer';
import SectionStatesWrapper from '../../../../../../common/components/configuratorStates/SectionStatesWrapper';

export interface IVariantSelectorBase {
  error?: Error;
  sectionName: string;
}

const VariantSelectorBase: FunctionComponent<IVariantSelectorBase> = ({ children, error, sectionName }) => {
  const { setExpandedSection, currentSection } = useExpandSections(sectionName);
  const styles = variantSelectorBaseStyles();

  return (
    <GenericAccordion
      expanded={currentSection}
      setExpanded={setExpandedSection}
      classes={{ accordionDetails: styles.container, accordionSummary: styles.accordionSummary }}
      dataTest={'container:section:variant_selector'}
      summary={<FeatureSectionTitleContainer label={sectionName} sectionCode={sectionName} />}
      details={<SectionStatesWrapper error={error}>{children}</SectionStatesWrapper>}
    />
  );
};

export default VariantSelectorBase;
